var _title, _desc, _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "90px",
    viewBox: "0 0 70 90",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "pdf-ico")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.09090909,-6.83118937e-15 L45.411377,-4.06123242e-15 L59.375,14.4848633 L59.375,75.9090909 C59.375,78.1684376 57.5434376,80 55.2840909,80 L4.09090909,80 C1.83156239,80 -6.11488249e-16,78.1684376 -8.8817842e-16,75.9090909 L-8.8817842e-16,4.09090909 C-1.16486859e-15,1.83156239 1.83156239,-4.02585684e-15 4.09090909,-4.4408921e-15 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.3%",
    y: "-8.1%",
    width: "128.6%",
    height: "121.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "45.625 0 59.588623 14.4848633 45.625 14.4848633"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-46.5%",
    y: "-38.0%",
    width: "193.1%",
    height: "189.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIDE-Kit-Copy-2",
    transform: "translate(-4302.000000, -1180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf-ico",
    transform: "translate(4307.000000, 1183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6D6D6",
    strokeWidth: 1,
    d: "M58.875,14.6866243 L45.1988837,0.5 L4.09090909,0.5 C2.10770476,0.5 0.5,2.10770476 0.5,4.09090909 L0.5,75.9090909 C0.5,77.8922952 2.10770476,79.5 4.09090909,79.5 L55.2840909,79.5 C57.2672952,79.5 58.875,77.8922952 58.875,75.9090909 L58.875,14.6866243 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21-Copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DFDFDF",
    strokeWidth: 1,
    d: "M46.125,1.23908949 L46.125,13.9848633 L58.412115,13.9848633 L46.125,1.23908949 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.7387745,43.0334543 C18.3687135,43.0334543 18.0135401,42.9132909 17.7104729,42.6867881 C16.6034803,41.8562777 16.4546052,40.9321887 16.5247891,40.3026597 C16.7183268,38.571455 18.858938,36.7594324 22.8891995,34.9133812 C24.4885434,31.4084361 26.0102596,27.0899949 26.9173342,23.4819006 C25.8560675,21.1722099 24.8245758,18.1755669 25.576395,16.4177773 C25.8401166,15.8020725 26.1687052,15.3299257 26.7822833,15.1257542 C27.024737,15.0449363 27.6372517,14.9428505 27.8626911,14.9428505 C28.3986415,14.9428505 28.8697248,15.6329929 29.2036304,16.0583503 C29.5173315,16.4581863 30.2287417,17.3057109 28.8069846,23.2915532 C30.2404391,26.2520408 32.2715207,29.2678249 34.2175309,31.3329352 C35.6116399,31.0809109 36.8111478,30.9522403 37.7884065,30.9522403 C39.4536807,30.9522403 40.4628412,31.3403789 40.8743745,32.1400509 C41.2146605,32.8014817 41.0753559,33.5745688 40.459651,34.4369809 C39.8673408,35.2653645 39.0506546,35.7034826 38.0989174,35.7034826 C36.8058308,35.7034826 35.3000656,34.8867964 33.6209672,33.2736284 C30.6041197,33.9042208 27.0810969,35.0292911 24.2333289,36.274525 C23.3443319,38.1609851 22.4925537,39.6805745 21.6992621,40.7950109 C20.6092837,42.3209807 19.6692438,43.0334543 18.7387745,43.0334543 Z M21.5695281,37.582499 C19.2970561,38.8596347 18.3708403,39.9092041 18.3038465,40.5004509 C18.2932126,40.5982831 18.264501,40.8556244 18.7621692,41.2363193 C18.9206148,41.1863398 19.8457672,40.7641725 21.5695281,37.582499 Z M36.0710259,32.8589049 C36.9376916,33.5256527 37.1493069,33.8627484 37.7160957,33.8627484 C37.9649298,33.8627484 38.6742133,33.8521145 39.0028019,33.3937919 C39.1612475,33.1715426 39.2229243,33.0290479 39.2473824,32.9524835 C39.116585,32.883363 38.9432518,32.742995 37.997895,32.742995 C37.4608812,32.7440584 36.7856263,32.7674531 36.0710259,32.8589049 Z M28.1274761,25.8596486 C27.3671497,28.4904842 26.3633062,31.3308084 25.2839618,33.9031574 C27.5064543,33.0407452 29.9224844,32.2878626 32.1917662,31.7551024 C30.7561849,30.0877013 29.3216671,28.0055768 28.1274761,25.8596486 Z M27.4819962,16.8612124 C27.3777837,16.8963044 26.0676828,18.7295949 27.584082,20.2810861 C28.5932425,18.0320087 27.5277221,16.8463249 27.4819962,16.8612124 Z",
    id: "Shape",
    fill: "#FE0400",
    fillRule: "nonzero",
    transform: "translate(28.782873, 28.988152) rotate(-10.000000) translate(-28.782873, -28.988152) "
  }), /*#__PURE__*/React.createElement("text", {
    id: ".pdf",
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontSize: 16.3636364,
    fontWeight: 500,
    fill: "#4F5E65"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.0246804,
    y: 68.9090909
  }, ".pdf")))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.1ab08fdf.svg";
export { ForwardRef as ReactComponent };